
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/la-para",
      function () {
        return require("private-next-pages/case-study/la-para.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/la-para"])
      });
    }
  